<template>
    <ui-sidebar-float
        :load="loader.load"
        :overlay-close="true"
        :title="`Histórico de Fila - ${data.id}`"
        loadText="Carregando..."
        name="marketing-queues-history-sidebar"
    >
        <ui-feed :has-header="!loader.load">
            <template #header>
                <div class="history-header">
                    <div class="col">
                        <div class="item">
                            <strong>Nome: </strong>
                            <span v-if="data.name">{{ data.name }}</span>
                            <span v-else>-</span>
                        </div>
                        <div class="item">
                            <strong>Status: </strong>
                            <span v-if="data.status">{{ getStatus(data.status) }}</span>
                            <span v-else>-</span>
                        </div>
                        <div class="item">
                            <strong>Total de Clientes: </strong>
                            <span v-if="data.leads">{{ data.leads }}</span>
                            <span v-else>-</span>
                        </div>
                    </div>
                    <div class="col -right">
                        <div class="item">
                            <strong>Última atualização: </strong>
                            <span v-if="data.updated_at">{{ data.updated_at | moment('DD/MM/YYYY') }}</span>
                            <span v-else>-</span>
                        </div>
                        <div class="item">
                            <strong>Próximo da fila: </strong>
                            <span v-if="next">{{ next }}ª posição</span>
                            <span v-else>-</span>
                        </div>
                    </div>
                </div>
            </template>

            <div v-if="historyComputed">
                <ui-queues-feed-card v-for="(item, index) in historyComputed" :key="index" :data="item" />
            </div>
        </ui-feed>
    </ui-sidebar-float>
</template>

<script>
    import { uiSidebarFloat, uiFeed } from '@/components/ui'
    import uiQueuesFeedCard from '../queues-history-feed-card'

    import { lead } from '@/services/axios'
    import { storage } from '@/services/storage'

    import { mapGetters } from 'vuex'

    const moment = require('moment')
    require('moment/locale/pt-br')

    export default {
        components: {
            uiSidebarFloat,
            uiFeed,
            uiQueuesFeedCard,
        },

        data() {
            return {
                loader: {
                    load: false,
                },
                data: {
                    id: '',
                    history: [],
                },
                configurations: {
                    groups: {
                        admin: storage.get('label_admin'),
                        collaborator: storage.get('label_collaborator'),
                        supervisor: storage.get('label_supervisor'),
                        manager: storage.get('label_manager'),
                        broker: storage.get('label_broker'),
                    },
                },
            }
        },

        mounted() {
            this.$root.$on('sidebar-open-marketing-queues-history', () => {
                this.loadHistory()
            })
        },

        beforeDestroy() {
            this.$root.$off('sidebar-open-marketing-queues-history')
        },

        computed: {
            ...mapGetters('lead', {
                leadQueue: 'getQueue',
            }),
            /**
             * Retorna a posição do próximo lead a ser processado
             */
            next() {
                return this.data.nextPosition && this.data.lusers && this.data.lusers.length > 0 ? this.data.nextPosition : '-'
            },
            /**
             * Forma o histórico da fila de leads de modo a ser mostrado
             */
            historyComputed() {
                return this.data.history
            },
        },

        methods: {
			/**
			 * Carrega os dados do histórico da fila de leads
			 */
			loadHistory() {
				if (!this.leadQueue) return
				this.$root.$emit('sidebar-open-marketing-queues-history-sidebar')
				this.$set(this.loader, 'load', true)
				lead.get('history', this.leadQueue.id || this.leadQueue.lead_id)
					.then(response => {
						this.data = { ...response.data }
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						this.$set(this.loader, 'load', false)
					})
			},
			/**
			 * Retorna a string correta de acordo com o status da fila de leads
			 */
			getStatus(status) {
				return status === 'active' ? 'Ativa' : 'Inativa'
			},
			/**
			 * Retorna o label do perfil do usuário
			 */
			getGroupLabel(group) {
				let label = ''
				switch (group) {
					case 'admin':
					case 'supervisor':
					case 'collaborator':
					case 'manager':
					case 'broker':
						label = this.configurations.groups[group]
						break

                    default:
                        label = group
                        break
                }

                return label
            },
        },
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>
